export const ListOfBrowserName = [
  'Adobe AIR',
  'Arora',
  'Avant Browser',
  'Breach',
  'Camino',
  'Electron',
  'Epiphany',
  'Fennec',
  'Flock',
  'Galeon',
  'GreenBrowser',
  'iCab',
  'Iceweasel',
  'K-Meleon',
  'Konqueror',
  'Lunascape',
  'Maxthon',
  { label: 'Microsoft Edge', pattern: '(?:Edge|Edg|EdgA|EdgiOS)' },
  'Midori',
  'Nook Browser',
  'PaleMoon',
  'PhantomJS',
  'Raven',
  'Rekonq',
  'RockMelt',
  { label: 'Samsung Internet', pattern: 'SamsungBrowser' },
  'SeaMonkey',
  { label: 'Silk', pattern: '(?:Cloud9|Silk-Accelerated)' },
  'Sleipnir',
  'SlimBrowser',
  { label: 'SRWare Iron', pattern: 'Iron' },
  'Sunrise',
  'Swiftfox',
  'Vivaldi',
  'Waterfox',
  'WebPositive',
  { label: 'Yandex Browser', pattern: 'YaBrowser' },
  { label: 'UC Browser', pattern: 'UCBrowser' },
  'Opera Mini',
  { label: 'Opera Mini', pattern: 'OPiOS' },
  'Opera',
  { label: 'Opera', pattern: 'OPR' },
  'Chromium',
  'Chrome',
  { label: 'Chrome', pattern: '(?:HeadlessChrome)' },
  { label: 'Chrome Mobile', pattern: '(?:CriOS|CrMo)' },
  { label: 'Firefox', pattern: '(?:Firefox|Minefield)' },
  { label: 'Firefox for iOS', pattern: 'FxiOS' },
  { label: 'IE', pattern: 'IEMobile' },
  { label: 'IE', pattern: 'MSIE' },
  'Safari'
];

export const BrowserSupportWebp = ['Chrome', 'Opera'];
